<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight + 'px'}">
    <div class="front" :class="{'active-front': isEdit}" ref="element">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp" >删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-count-money :comData="value" />
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <count-money v-model="formData" :basicInfoForm="basicInfoForm" :isDit="isEditActivity" ref="countMoneyRef" />
      <!-- <div style="height: 60px;"></div> -->
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "@/utils/dayjs";
import { mapGetters } from 'vuex'
import previewCountMoney from '@/pages/activity-home/components/count-money'
import countMoney from '../../components/count-money'
import _ from 'loadsh'
export default {
  components: {
    previewCountMoney,
    countMoney,
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    basicInfoForm: Object
  },
  computed: {
    ...mapGetters({
      // 经销商
      isDistributor: 'isDistributor',
      // 店长
      isShopowner: 'isShopowner',
      // 导购
      isGuide: 'isGuide',
      // 活动老师
      isTeacher: 'isTeacher',
    }),
    isEditActivity() {
      return this.$route.query.from == 'manager' ? true : false
    }
  },
  data() {
    return {
      isEdit: false,
      formData: {},
      pagesHeight: '231',
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.formData = _.cloneDeep(this.value)
        }
      },
      deep: true,
      immediate: true
    },
    // basicInfoForm: {
    //   handler(newVal,oldVal) {
    //     if (newVal.startTime && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
    //       this.initTimeSet()
    //     }
    //   },
    // },
  },
  mounted() {
    // 获取组件高度
   this.$nextTick(()=> {
    let height = this.$refs.element.offsetHeight;
    this.pagesHeight = height  == '0' ? '231' : height
   })
  },
  methods: {
    edit() {
      this.formData = _.cloneDeep(this.value)
      this.isEdit = !this.isEdit
      this.$emit('handle',['countMoney',false])
    },
    cancel() {
      // 把没改变之前的数据重新赋值给组件
      this.formData = _.cloneDeep(this.value)
      this.isEdit = false
      this.$emit('handle', ['countMoney',true])
    },
    async save() {
      await this.$refs.countMoneyRef.verifyParames()
      this.$emit('change', this.formData)
      this.$nextTick(()=> {
        this.pagesHeight = this.$refs.element.offsetHeight
        this.isEdit = false
        this.$emit('handle', ['countMoney',true])
      })
    },
    // initTimeSet() {
    //   let { startTime,endTime } = {...this.basicInfoForm}
    //   if (!startTime) return
    //   this.value.countMoneyStartTime = startTime.split(" ").length > 1 ? startTime : startTime + " 00:00:00";
    //   endTime = endTime.split(" ").length > 1 ? endTime : endTime + " 23:59:59";
    //   this.value.countMoneyEndTime = endTime;
    //   let date = endTime.replace(/-/g, "/");
    //   this.value.exchangeEndDate =  dayjs(new Date(date).getTime() + 86400000).format('YYYY-MM-DD HH:mm:ss');
    //   this.$emit('change', this.value)
    // },
    verifyParames() {
      return this.$refs.countMoneyRef.verifyParames()
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }

}
</script>

<style lang="stylus" scoped>
.com-box {
  position: relative;
  perspective: 800px;
  overflow hidden
  padding: 10px 0;
  box-sizing: border-box;
  // background: blue;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    z-index: 1;
    backface-visibility: hidden;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    margin-top: -10px;
    background: #fff;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #F4F4F4;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>